<template>
  <v-layout row justify-center>
    <v-dialog v-model="visible" width="40%" v-click-outside="close">
      <v-card>
        <v-layout column justify-center>
          <v-img contain :src="logo" style="padding:15px;margin:15px"/> 
          <v-divider></v-divider>

          <v-layout row justify-center>
            <v-btn flat @click="onLicenseClick">
              {{ this.$t('Licenses') }}
            </v-btn>
          </v-layout>
          <v-divider></v-divider>

          <div style="margin:15px;white-space:pre">
            {{name}}
            <div class="caption">
              {{clientVersion}}
              {{coreVersion}}
              {{serverVersion}}
            </div>
          </div>
          
        </v-layout>      
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script> 
  const appVersion = require('../../../package.json').version

  export default {
    name: 'about',
    data: () => ({
      name: "",
      clientVersion: "",
      coreVersion: "",
      serverVersion: ""
    }),
    props: {
      visible: {
        type: Boolean, 
        default: false
      },
    },
    computed: {
      logo() {
        return require('@assets/images/app-logo.png')
      }
    },
    methods: {
      close() {
        if (!this.visible)
          return
        this.$emit('update:visible', false)
      },
      onLicenseClick() {
        const link = 'http://safeswiss.download/win/license'
        this.$store.dispatch('openLink', link)
      }
    },
    updated() {
      this.$store.dispatch('getCoreVersion').then((resp) => {
        console.log("--about this.$store.appVersion:"+this.$store.getters.getServerId)
        this.name = this.$t('about_name',[new Date().getFullYear()])
        this.clientVersion = this.$t('about_client_version', [appVersion])
        this.coreVersion = this.$t('about_core_version', [resp])
        this.serverVersion = this.$t('about_server_version', [this.$store.getters.getServerId])
      })
    }
  }
</script>